import React, { useEffect } from 'react';

import type { Row } from 'react-table';

import { NO_ROUTE_ID } from '../../../../../stores/routes-planner-store';
import type { RoutesPlannerTask } from '../../../../../types';
import { UpdatingSource } from '../../../../types';
import { IndeterminateCheckbox } from '../../../planner-table';

interface Props {
	row: Row<RoutesPlannerTask>;
	selectedTasksIds: number[];
	tasksById: Map<number, RoutesPlannerTask>;
	changeTasksSelection: (tasksIds: number[], source: UpdatingSource) => void;
}

const TaskSelectColumn = ({ row, selectedTasksIds, tasksById, changeTasksSelection }: Props) => {
	const isTaskUnassigned = row.original.run_id === NO_ROUTE_ID || (!row.original.user_id && !row.original.vehicle_id);
	const task = row.original;

	useEffect(() => {
		if (isTaskUnassigned) return;

		const isTaskSelectedAndNotChecked = selectedTasksIds.includes(task.id) && !checked;
		const isTaskNotSelectedAndChecked = !selectedTasksIds.includes(task.id) && checked;

		if (isTaskSelectedAndNotChecked || isTaskNotSelectedAndChecked) {
			row.toggleRowSelected();
		}
	}, [selectedTasksIds]);

	const { indeterminate, checked, onChange } = row.getToggleRowSelectedProps();
	const firstSelectedTask = tasksById.get(selectedTasksIds[0]);
	const isDisabled = firstSelectedTask && firstSelectedTask.run_id !== task.run_id;

	const onCheck = e => {
		const removeMeFromSelectedTasks = selectedTasksIds.filter(taskId => taskId !== task.id);
		const addMeToSelectedTasks = [...selectedTasksIds, task.id];
		const tasksIdsToSelect = checked ? removeMeFromSelectedTasks : addMeToSelectedTasks;

		changeTasksSelection(tasksIdsToSelect, UpdatingSource.PlannerTable);
		onChange(e);
	};

	if (isTaskUnassigned) return null;

	return (
		<div className="task-selected-checkbox">
			<IndeterminateCheckbox
				indeterminate={indeterminate}
				checked={checked}
				onChange={onCheck}
				disabled={isDisabled}
			/>
		</div>
	);
};

export default TaskSelectColumn;
